import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';

const FormBox = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    gap: theme.spacing(2),
    margin: 'auto',
  }));

  export default FormBox;